/**
 * Air Search Perf events.
 * */
export const PERF_EVENTS = Object.freeze({
  buildSearchRequestStart: 'a.bsr.s', // build search request (start)
  airSchemaSearchRequestEnd: 'a.sbsr.e', // // build search request (end)
  AirSearchSchemaReq: 'a.sfsr', // fire search request
  successGraphAirSearchRsp: 'a.grsr', // received search response
  transformGraphAirSearchRspStart: 'a.gtsr.s', // transform search response (start)
  transformGraphAirSearchRspEnd: 'a.gtsr.e', // transform search response (end)
  renderGraphListingsStart: 'a.grl.s', // render listings (start)
  renderGraphListingsEnd: 'a.grl.e', // render listings (end)
  renderGraphSearchRefreshOverlay: 'a.gsro', // render SearchRefreshOverlay
  renderFiltersLazilyStart: 'a.fl.s', // render the Filters using React.lazy (start)
  renderFiltersLazilyEnd: 'a.fl.e', // render the Filters (end)
})
